import { UseMutationOptions } from '@tanstack/react-query';

export type ApiFnReturnType<FnType extends (...args: any) => Promise<any>> = Awaited<ReturnType<FnType>>;

export type MutationConfig<MutationFnType extends (...args: any) => Promise<any>> = UseMutationOptions<
  ApiFnReturnType<MutationFnType>,
  Error,
  Parameters<MutationFnType>[0]
>;

type MutationOptions<MutationFnType extends (...args: any) => Promise<any>> = {
  config?: MutationConfig<MutationFnType>;
  mutationFn: MutationFnType;
};

export const mutationOptions = <MutationFnType extends (...args: any) => Promise<any>>({
  config,
  mutationFn,
}: MutationOptions<MutationFnType>) => {
  return {
    ...config,
    mutationFn,
  };
};
